import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Output, Input, NgModule } from '@angular/core';
import * as i1 from 'cloud-labs-core';
import * as i2 from 'devextreme-angular';
import { DxDataGridModule, DxTreeListModule, DxLookupModule, DxLoadPanelModule, DxButtonModule, DxTextBoxModule, DxNumberBoxModule, DxSwitchModule, DxCheckBoxModule, DxTabsModule, DxPopupModule, DxTextAreaModule, DxPopoverModule, DxSliderModule, DxRadioGroupModule, DxSelectBoxModule, DxFormModule, DxScrollViewModule, DxTagBoxModule, DxDateBoxModule, DxValidatorModule, DxLoadIndicatorModule, DxDropDownBoxModule, DxHtmlEditorModule, DxColorBoxModule, DxToastModule, DxTooltipModule, DxTemplateModule, DxFilterBuilderModule } from 'devextreme-angular';
import * as i3 from 'devextreme-angular/ui/nested';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i5 from 'devextreme-angular/core';
import * as i6 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';

class CloudLabsLoginService {
    constructor() { }
}
CloudLabsLoginService.ɵfac = function CloudLabsLoginService_Factory(t) { return new (t || CloudLabsLoginService)(); };
CloudLabsLoginService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CloudLabsLoginService, factory: CloudLabsLoginService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CloudLabsLoginService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function CloudLabsLoginComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "i", 20);
    i0.ɵɵtext(2, "error");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r2.error, " ");
} }
function CloudLabsLoginComponent_div_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "dx-load-indicator", 21);
    i0.ɵɵelementStart(2, "span", 22);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("visible", ctx_r4.loadIndicatorVisible);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, "Login"));
} }
function CloudLabsLoginComponent_div_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "dx-load-indicator", 21);
    i0.ɵɵelementStart(2, "span", 22);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("visible", ctx_r5.lostPasswordIndicator);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 2, "Reset Password"));
} }
class CloudLabsLoginComponent {
    constructor(ls) {
        this.ls = ls;
        this.loginStatus = new EventEmitter();
        this.status = "login";
        this.loadIndicatorVisible = false;
        this.lostPasswordIndicator = false;
    }
    ngOnInit() {
        this.ls.apiKey = this.apikey;
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.autoLogin();
        }, 1);
    }
    autoLogin() {
        this.loadIndicatorVisible = true;
        this.ls.autoLogin().then(o => {
            console.log("o", o);
            this.loadIndicatorVisible = false;
            if (o == "ok") {
                this.loginStatus.emit({ status: login_enum.loggedin, message: "" });
            }
        }, e => {
            this.loginStatus.emit({ status: login_enum.loggedout, message: e });
            this.error = e;
            this.error = this.error.toLocaleUpperCase();
            this.loadIndicatorVisible = false;
        });
    }
    login(e) {
        e.preventDefault();
        this.error = undefined;
        this.loadIndicatorVisible = true;
        this.ls.login(this.user, this.pass).then(o => {
            this.loadIndicatorVisible = false;
            this.loginStatus.emit({ status: login_enum.loggedin, message: "" });
        }, error => {
            this.loginStatus.emit({ status: login_enum.loggedout, message: error });
            this.loadIndicatorVisible = false;
            this.error = error;
            this.error = this.error.toLocaleUpperCase();
        });
    }
    lostPassword() {
        this.lostPasswordIndicator = true;
        this.ls.lostPassword(this.user).then(o => {
            this.lostPasswordIndicator = false;
            this.error = "Şifre sıfırlama epostanız gönderildi.";
        }, e => {
            this.error = e;
            this.error = this.error.toLocaleUpperCase();
            this.lostPasswordIndicator = false;
        });
    }
}
CloudLabsLoginComponent.ɵfac = function CloudLabsLoginComponent_Factory(t) { return new (t || CloudLabsLoginComponent)(i0.ɵɵdirectiveInject(i1.CloudLoginService)); };
CloudLabsLoginComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CloudLabsLoginComponent, selectors: [["lib-cloud-labs-login"]], inputs: { apikey: "apikey" }, outputs: { loginStatus: "loginStatus" }, decls: 37, vars: 42, consts: [[1, "cloudie-login-box"], [1, "header"], [3, "submit"], [1, "content"], [1, "field"], [3, "stylingMode", "placeholder", "value", "showClearButton", "valueChange"], ["username1", ""], ["type", "required", 3, "message"], ["type", "email", 3, "message"], ["mode", "password", 3, "stylingMode", "placeholder", "value", "showClearButton", "valueChange"], ["password1", ""], ["class", "error", 4, "ngIf"], [1, "remember-me"], [3, "value", "valueChange"], ["remember", ""], [1, "buttons"], ["type", "success", "useSubmitBehavior", "true", 3, "width", "text", "disabled"], [4, "dxTemplate", "dxTemplateOf"], ["type", "danger", 3, "stylingMode", "width", "text", "disabled", "onClick"], [1, "error"], [1, "material-icons-outlined", "md-18", 2, "padding-right", "4px"], [1, "button-indicator", 3, "visible"], [1, "dx-button-text"]], template: function CloudLabsLoginComponent_Template(rf, ctx) { if (rf & 1) {
        const _r8 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵtext(2);
        i0.ɵɵpipe(3, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "form", 2);
        i0.ɵɵlistener("submit", function CloudLabsLoginComponent_Template_form_submit_4_listener($event) { return ctx.login($event); });
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵelementStart(7, "dx-text-box", 5, 6);
        i0.ɵɵlistener("valueChange", function CloudLabsLoginComponent_Template_dx_text_box_valueChange_7_listener($event) { return ctx.user = $event; });
        i0.ɵɵpipe(9, "translate");
        i0.ɵɵelementStart(10, "dx-validator");
        i0.ɵɵelement(11, "dxi-validation-rule", 7);
        i0.ɵɵpipe(12, "translate");
        i0.ɵɵelement(13, "dxi-validation-rule", 8);
        i0.ɵɵpipe(14, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "div", 4);
        i0.ɵɵelementStart(16, "dx-text-box", 9, 10);
        i0.ɵɵlistener("valueChange", function CloudLabsLoginComponent_Template_dx_text_box_valueChange_16_listener($event) { return ctx.pass = $event; });
        i0.ɵɵpipe(18, "translate");
        i0.ɵɵelementStart(19, "dx-validator");
        i0.ɵɵelement(20, "dxi-validation-rule", 7);
        i0.ɵɵpipe(21, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(22, CloudLabsLoginComponent_div_22_Template, 4, 1, "div", 11);
        i0.ɵɵelementStart(23, "div", 12);
        i0.ɵɵelementStart(24, "span");
        i0.ɵɵtext(25);
        i0.ɵɵpipe(26, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(27, "\u00A0 ");
        i0.ɵɵelementStart(28, "dx-switch", 13, 14);
        i0.ɵɵlistener("valueChange", function CloudLabsLoginComponent_Template_dx_switch_valueChange_28_listener() { i0.ɵɵrestoreView(_r8); const _r3 = i0.ɵɵreference(29); return ctx.ls.setRemember(_r3.value); })("valueChange", function CloudLabsLoginComponent_Template_dx_switch_valueChange_28_listener($event) { return ctx.ls.remember = $event; });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(30, "div", 15);
        i0.ɵɵelementStart(31, "dx-button", 16);
        i0.ɵɵpipe(32, "translate");
        i0.ɵɵtemplate(33, CloudLabsLoginComponent_div_33_Template, 5, 4, "div", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "dx-button", 18);
        i0.ɵɵlistener("onClick", function CloudLabsLoginComponent_Template_dx_button_onClick_34_listener() { return ctx.lostPassword(); });
        i0.ɵɵpipe(35, "translate");
        i0.ɵɵtemplate(36, CloudLabsLoginComponent_div_36_Template, 5, 4, "div", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 24, "Login"), " ");
        i0.ɵɵadvance(5);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(9, 26, "User name"));
        i0.ɵɵproperty("stylingMode", "filled")("value", ctx.user)("showClearButton", true);
        i0.ɵɵadvance(4);
        i0.ɵɵpropertyInterpolate("message", i0.ɵɵpipeBind1(12, 28, "User name Required"));
        i0.ɵɵadvance(2);
        i0.ɵɵpropertyInterpolate("message", i0.ɵɵpipeBind1(14, 30, "Invalid Email Address"));
        i0.ɵɵadvance(3);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(18, 32, "Password"));
        i0.ɵɵproperty("stylingMode", "outlined")("value", ctx.pass)("showClearButton", true);
        i0.ɵɵadvance(4);
        i0.ɵɵpropertyInterpolate("message", i0.ɵɵpipeBind1(21, 34, "Password Required"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.error != undefined);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(26, 36, "Remember Me!"));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("value", ctx.ls.remember);
        i0.ɵɵadvance(3);
        i0.ɵɵpropertyInterpolate("text", i0.ɵɵpipeBind1(32, 38, "Login"));
        i0.ɵɵproperty("width", 100)("disabled", ctx.loadIndicatorVisible);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("dxTemplateOf", "content");
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("text", i0.ɵɵpipeBind1(35, 40, "Lost Password"));
        i0.ɵɵproperty("stylingMode", "text")("width", 190)("disabled", ctx.loadIndicatorVisible);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("dxTemplateOf", "content");
    } }, directives: [i2.DxTextBoxComponent, i2.DxValidatorComponent, i3.DxiValidationRuleComponent, i4.NgIf, i2.DxSwitchComponent, i2.DxButtonComponent, i5.DxTemplateDirective, i2.DxLoadIndicatorComponent], pipes: [i6.TranslatePipe], styles: ["body[_ngcontent-%COMP%]{background-color:var(--workspace-background);color:var(--workspace-text)}.cloudie-login-box[_ngcontent-%COMP%]{min-width:300px;min-height:210px}.header[_ngcontent-%COMP%]{width:100%;height:40px;text-align:center;vertical-align:middle;font-family:\"Montserrat\",sans-serif;font-size:1.2em;font-weight:bold;line-height:normal;align-items:center}.label[_ngcontent-%COMP%]{display:inline-block;width:100px;padding:5px}.field[_ngcontent-%COMP%]{display:flex;flex-flow:column-reverse;margin-bottom:1em}.error[_ngcontent-%COMP%]{font-family:\"Montserrat\",sans-serif;font-size:14px;color:#ff0;align-items:center;display:flex;justify-content:center}label[_ngcontent-%COMP%], input[_ngcontent-%COMP%]{font-family:\"Montserrat\",sans-serif;transition:all .2s;touch-action:manipulation}input[_ngcontent-%COMP%]{font-family:\"Montserrat\",sans-serif;font-size:16px;border:0;border-bottom:1px solid #ccc;font-family:inherit;-webkit-appearance:none;border-radius:0;padding:0;cursor:text}input[_ngcontent-%COMP%]:focus{outline:0;border-bottom:1px solid #666}label[_ngcontent-%COMP%]{text-transform:uppercase;letter-spacing:.05em}[_ngcontent-%COMP%]::-webkit-input-placeholder{opacity:0;-webkit-transition:inherit;transition:inherit}input[_ngcontent-%COMP%]:focus::-webkit-input-placeholder{opacity:1}button[_ngcontent-%COMP%]{border:1px solid grey;background-color:#4682b4;font-family:\"Montserrat\",sans-serif;color:#fff;width:150px;height:30px;float:right}@media screen and (max-width: 600px){.login-box[_ngcontent-%COMP%]{width:70%;height:500px;position:fixed;top:20%;left:20%}}.button-indicator[_ngcontent-%COMP%]{height:20px;width:20px;display:inline-block;vertical-align:middle;margin-right:5px}.remember-me[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:flex-end;font-family:\"Montserrat\",sans-serif;font-size:12px;margin-bottom:15px;align-items:center}.buttons[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CloudLabsLoginComponent, [{
        type: Component,
        args: [{
                selector: 'lib-cloud-labs-login',
                templateUrl: './cloud-labs-login.component.html',
                styleUrls: ['./cloud-labs-login.component.css']
            }]
    }], function () { return [{ type: i1.CloudLoginService }]; }, { loginStatus: [{
            type: Output
        }], apikey: [{
            type: Input
        }] }); })();
var login_enum;
(function (login_enum) {
    login_enum[login_enum["loggedin"] = 0] = "loggedin";
    login_enum[login_enum["loggedout"] = 1] = "loggedout";
})(login_enum || (login_enum = {}));

class CloudLabsLoginModule {
}
CloudLabsLoginModule.ɵfac = function CloudLabsLoginModule_Factory(t) { return new (t || CloudLabsLoginModule)(); };
CloudLabsLoginModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CloudLabsLoginModule });
CloudLabsLoginModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TranslateModule,
            DxDataGridModule,
            DxTreeListModule,
            DxLookupModule,
            DxLoadPanelModule,
            DxButtonModule,
            DxTextBoxModule,
            DxNumberBoxModule,
            DxSwitchModule,
            DxCheckBoxModule,
            DxTabsModule,
            DxPopupModule,
            DxTextAreaModule,
            DxPopoverModule,
            DxSliderModule,
            DxRadioGroupModule,
            DxSelectBoxModule,
            DxFormModule,
            DxScrollViewModule,
            DxTagBoxModule,
            DxDateBoxModule,
            DxValidatorModule,
            DxLoadIndicatorModule,
            DxSwitchModule,
            DxDropDownBoxModule,
            DxHtmlEditorModule,
            DxColorBoxModule,
            DxToastModule,
            DxTooltipModule,
            DxTemplateModule,
            DxFilterBuilderModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CloudLabsLoginModule, [{
        type: NgModule,
        args: [{
                declarations: [CloudLabsLoginComponent],
                imports: [
                    CommonModule,
                    TranslateModule,
                    DxDataGridModule,
                    DxTreeListModule,
                    DxLookupModule,
                    DxLoadPanelModule,
                    DxButtonModule,
                    DxTextBoxModule,
                    DxNumberBoxModule,
                    DxSwitchModule,
                    DxCheckBoxModule,
                    DxTabsModule,
                    DxPopupModule,
                    DxTextAreaModule,
                    DxPopoverModule,
                    DxSliderModule,
                    DxRadioGroupModule,
                    DxSelectBoxModule,
                    DxFormModule,
                    DxScrollViewModule,
                    DxTagBoxModule,
                    DxDateBoxModule,
                    DxValidatorModule,
                    DxLoadIndicatorModule,
                    DxSwitchModule,
                    DxDropDownBoxModule,
                    DxHtmlEditorModule,
                    DxColorBoxModule,
                    DxToastModule,
                    DxTooltipModule,
                    DxTemplateModule,
                    DxFilterBuilderModule,
                ],
                exports: [CloudLabsLoginComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CloudLabsLoginModule, { declarations: [CloudLabsLoginComponent], imports: [CommonModule,
        TranslateModule,
        DxDataGridModule,
        DxTreeListModule,
        DxLookupModule,
        DxLoadPanelModule,
        DxButtonModule,
        DxTextBoxModule,
        DxNumberBoxModule,
        DxSwitchModule,
        DxCheckBoxModule,
        DxTabsModule,
        DxPopupModule,
        DxTextAreaModule,
        DxPopoverModule,
        DxSliderModule,
        DxRadioGroupModule,
        DxSelectBoxModule,
        DxFormModule,
        DxScrollViewModule,
        DxTagBoxModule,
        DxDateBoxModule,
        DxValidatorModule,
        DxLoadIndicatorModule,
        DxSwitchModule,
        DxDropDownBoxModule,
        DxHtmlEditorModule,
        DxColorBoxModule,
        DxToastModule,
        DxTooltipModule,
        DxTemplateModule,
        DxFilterBuilderModule], exports: [CloudLabsLoginComponent] }); })();

/*
 * Public API Surface of cloud-labs-login
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CloudLabsLoginComponent, CloudLabsLoginModule, CloudLabsLoginService };
